module.exports = __webpack_public_path__ + "static/media/vu.5bc20756.svg";